import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MedicalGuide } from 'src/app/shared/models/api';
import { AppState, Province } from 'src/app/shared/models/state';
import { ApiService } from 'src/app/shared/services/api.service';
import { StateService } from 'src/app/shared/services/state.service';
import { UiService } from 'src/app/shared/services/ui.service';
@Component({
  selector: 'app-download-medical-guide',
  templateUrl: './download-medical-guide.component.html',
  styleUrls: ['./download-medical-guide.component.scss'],
})
export class DownloadMedicalGuideComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  isAutocompleteOpen: boolean;
  subs: Subscription;
  state: Partial<AppState>;
  provincesFiltered: Province[];
  medicalGuide: MedicalGuide;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public ui: UiService,
    public dialog: MatDialog,
    private stateService: StateService,
    private api: ApiService,
    private formBuilder: FormBuilder
  ) {
    this.subs = new Subscription();
    this.isAutocompleteOpen = false;
  }

  ngOnInit(): void {
    this.medicalGuide = this.data.medicalGuide;
    this.subs.add(
      this.stateService.getState().subscribe(state => {
        this.state = state;
        this.setFormGroup();
      }));
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  displayFn(province: Province): string {
    return province?.nombreProvincia || '';
  }

  allowOnlyProvinceSuggestedOptions() {
    const value = this.formGroup.value.province;

    if (typeof value === 'string') {
      const control = this.formGroup.get('province');
      const province = this.state.provinces?.find(s => s.nombreProvincia?.toLowerCase() === value?.toLowerCase());
      if (province) {
        control.setValue(province);
        return;
      }

      control.setErrors({ provinceInvalid: true });
      control.markAllAsTouched();
    }
  }

  downloadPdf() {
    this.api.downloadMedicalGuidePdf(
      this.medicalGuide,
      this.formGroup.value.province
    );
  }

  private setFormGroup() {
    this.formGroup = this.formBuilder.group({
      province: [null, [Validators.required]],
    });

    this.formGroup.get('province').valueChanges.subscribe(v => {
      if (typeof v === 'string') {
        this.provincesFiltered = this.state?.provinces
          ?.filter(s => s.nombreProvincia?.toLowerCase().includes(v?.toLowerCase()));
      }
    });
  }
}
